import TransferDestination from "manifest-components/src/classes/transferDestination";
import TransferInstruction from "manifest-components/src/classes/transferInstruction";
import { ProviderMailingDetails } from "manifest-components/src/api/APITransferInstruction";

export const TransferStatusState = {
  currentTransferInstruction: new TransferInstruction(),
  rothTransferredDestinations: [] as TransferDestination[],
  currentTransferInstructionFetched: false,
  fetchingCurrentTransferInstruction: false,
  settingTransferInProgress: false,
  fetchingRothTransferredDestinations: false,
  rothTransferredDestinationsFetched: false,
  destinationConnectedToTransfer: false,
  connectingDestinationToTransfer: false,
  providerMailingDetails: {} as ProviderMailingDetails,
  fetchingProviderMailingDetails: false,
  providerMailingDetailsFetched: false,
  mailConfirmed: false,
};
